import { render, staticRenderFns } from "./CancelledChequeCollectionActivity.vue?vue&type=template&id=7d061ca3&scoped=true&"
import script from "./CancelledChequeCollectionActivity.vue?vue&type=script&lang=js&"
export * from "./CancelledChequeCollectionActivity.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=7d061ca3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d061ca3",
  null
  
)

export default component.exports